import { routeName } from '@/constants/routeName';
import { hubSelectorTypeMapper } from '@/constants/hubSelectorTypeMapper';
export default {
    isBaromoneyWithdrawInProgress: (state) => state.viewState.baromoney.baromoneyWithdraw.isInProgress,
    isFetching: (state) => state.fetching > 0,
    isPending: (state) => state.isPending,
    activeTabIndex: (state) => state.viewState.tabs.activeTabIndex,
    isSearchOpened: (state) => state.viewState.isSearchOpened,
    searchQuery: (state) => state.viewState.searchQuery,
    isOverlay: (state) => state.viewState.isSearchOpened && !state.viewState.searchQuery,
    searchOrder: (state) => (orderList) => {
        const { searchQuery } = state.viewState;
        return orderList.filter(({ orderId, hubName, pickupAddressMemo, dropAddressDong, dropAddressLi, dropAddressJibun, dropAddressBuildingName, dropAddressDetail, allocatedWorkerName, }) => [
            orderId.toString(),
            hubName,
            pickupAddressMemo,
            dropAddressDong,
            dropAddressLi,
            dropAddressJibun,
            dropAddressBuildingName,
            dropAddressDetail,
            allocatedWorkerName,
        ].join('%')
            .toLowerCase()
            .includes(searchQuery?.toLowerCase()));
    },
    // 페이지 체크
    isControlPage: (state) => hubSelectorTypeMapper.control.includes(state.viewState.currentPageName),
    // TODO: 확장성 고려하여 하나의 값에 ENUM or 여러 값에 boolean
    isType0Page: (state) => hubSelectorTypeMapper.type0.includes(state.viewState.currentPageName),
    isType1Page: (state) => hubSelectorTypeMapper.type1.includes(state.viewState.currentPageName),
    isType2Page: (state) => hubSelectorTypeMapper.type2.includes(state.viewState.currentPageName),
    isType3Page: (state) => hubSelectorTypeMapper.type3.includes(state.viewState.currentPageName),
    isType4Page: (state) => hubSelectorTypeMapper.type4.includes(state.viewState.currentPageName),
    isType5Page: (state) => hubSelectorTypeMapper.type5.includes(state.viewState.currentPageName),
    isMapControlPage: (state) => state.viewState.currentPageName === routeName.MAP_CONTROL,
    getterCurrentPageName: (state) => state.viewState.currentPageName,
    getterPageTitle: (state) => state.viewState.pageTitle,
};
